/**
 * Splits the last `n` months into one `{ start, end }` range per calendar month, oldest first, in UTC.
 *
 * Each range spans a single month (first day → first day of the next), so callers can fetch per
 * month instead of one wide range: smaller queries, and each can load or fail independently.
 */
export function getLastNMonthsRanges(n: number): { start: Date; end: Date }[] {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  return Array.from({ length: n }, (_, i) => ({
    start: new Date(Date.UTC(year, month - n + 1 + i, 1)),
    end: new Date(Date.UTC(year, month - n + 2 + i, 1)),
  }));
}
